import { render, staticRenderFns } from "./OrteMapCard.vue?vue&type=template&id=0842975a&scoped=true&"
import script from "./OrteMapCard.vue?vue&type=script&lang=js&"
export * from "./OrteMapCard.vue?vue&type=script&lang=js&"
import style0 from "./OrteMapCard.vue?vue&type=style&index=0&id=0842975a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0842975a",
  null
  
)

export default component.exports